import React, { useEffect, useRef, useState } from 'react';
import BillingBalance from '../../billing/BillingBalance';
import { useSelector } from 'react-redux';
import { FiCamera, FiSend, FiUploadCloud } from 'react-icons/fi';
import './Detail_omr.scss';
import Button from '@mui/material/Button';
import CircularProgress from '@mui/material/CircularProgress';
import Modal from '@mui/material/Modal';
import fnc from '../../mymod/commFunction';
import { assessEssay, extractOmrAnswerSheet, gradeOmrAnswerSheets } from '../../page_aiEssay/services/essayApi';
import {
    createEssayAttachmentValue,
    ESSAY_IMAGE_ACCEPT,
    prepareEssayAttachment,
    releaseEssayAttachmentValue,
} from '../../page_aiEssay/utils/imageUtils';
import MathMarkdown from '../../page_aiEssay/components/MathMarkdown';
import AnswerSheetCropModal from './AnswerSheetCropModal';

const normalizeAnswer = (value) => String(value ?? '').trim().toLocaleLowerCase();

const formatShortAnswerForKatex = (value) => {
  const source = String(value ?? '').trim();
  if (!source || source.includes('$')) return source;
  const looksLikeMath = /[0-9\\^_{}=+\-*/<>≤≥°π√]/.test(source);
  if (!looksLikeMath) return source;
  return `$${source.replace(/°/g, '^{\\circ}')}$`;
};

const createEmptyAnswerSheetState = () => ({
  attachment: null,
  answers: {},
  warnings: [],
  status: 'idle',
  error: '',
});

const normalizeIncomingImageFile = (sourceFile, prefix) => {
  if (!sourceFile || sourceFile.name) return sourceFile;
  const extensionByType = {
    'image/jpeg': 'jpg',
    'image/png': 'png',
    'image/webp': 'webp'
  };
  const extension = extensionByType[sourceFile.type] || 'png';
  return new File([sourceFile], `${prefix}-${Date.now()}.${extension}`, {
    type: sourceFile.type,
    lastModified: Date.now()
  });
};

const getGradeLevel = (schoolLevel) => {
    const value = String(schoolLevel || '');
    if (value.includes('초')) return 'elementary';
    if (value.includes('중')) return 'middle';
    if (value.includes('고')) return 'high';
    return 'all';
};

const buildRubricText = (item) => {
  const criteriaText = (item.criteria || [])
    .map((criterion, index) => {
        const valueLabel = criterion.valueType === 'ratio'
            ? `배율 ${criterion.value}`
            : `${criterion.value}점`;
        return `${index + 1}. [${valueLabel}] ${criterion.text}`;
    })
    .join('\n');
  const modelAnswerText = String(item.modelAnswerText || '').trim();
  return [
    criteriaText,
    modelAnswerText ? `교사 모범 답안:\n${modelAnswerText}` : ''
  ].filter(Boolean).join('\n\n');
};

const Detail_omr = ({isRefresh, setIsRefresh}) => { 
    const [selectedValues, setSelectedValues] = useState({});
    const [list, setList] = useState([]);
    const [essayStates, setEssayStates] = useState({});
    const [answerSheetState, setAnswerSheetState] = useState(createEmptyAnswerSheetState);
    const [modelAnswerSheet, setModelAnswerSheet] = useState({ imageKey: '', imageName: '' });
    const [questionSettingsReady, setQuestionSettingsReady] = useState(false);
    const [submissionStage, setSubmissionStage] = useState('idle');
    const isSubmitting = submissionStage !== 'idle';
    const [isCroppingAnswerSheet, setIsCroppingAnswerSheet] = useState(false);
    const submissionInProgressRef = useRef(false);
    const [answerSheetCropFile, setAnswerSheetCropFile] = useState(null);
    const lmsListCode = useSelector(state => state.reduxStore.lmsListCode);
    const choJoongGo = useSelector(state => state.reduxStore.choJoongGo);
    const essayStatesRef = useRef({});
    const answerSheetStateRef = useRef(createEmptyAnswerSheetState());
    const answerSheetRequestRef = useRef(0);
    const answerSheetCameraInputRef = useRef(null);

    useEffect(() => {
        Object.values(essayStatesRef.current).forEach((state) => {
            releaseEssayAttachmentValue(state?.attachment);
        });
        releaseEssayAttachmentValue(answerSheetStateRef.current?.attachment);
        answerSheetRequestRef.current += 1;
        setSelectedValues({});
        setEssayStates({});
        setAnswerSheetState(createEmptyAnswerSheetState());
        setModelAnswerSheet({ imageKey: '', imageName: '' });
        setAnswerSheetCropFile(null);
        setIsCroppingAnswerSheet(false);
        setQuestionSettingsReady(false);
        setList([]);
        if (lmsListCode) fncSelect_list();
      }, [lmsListCode]);

    useEffect(() => {
        essayStatesRef.current = essayStates;
    }, [essayStates]);

    useEffect(() => {
        answerSheetStateRef.current = answerSheetState;
    }, [answerSheetState]);

    useEffect(() => () => {
        Object.values(essayStatesRef.current).forEach((state) => {
            releaseEssayAttachmentValue(state?.attachment);
        });
        releaseEssayAttachmentValue(answerSheetStateRef.current?.attachment);
        answerSheetRequestRef.current += 1;
    }, []);

    const markRecognizedAnswerReviewed = (munNo) => {
      setAnswerSheetState((current) => {
        const recognized = current.answers?.[munNo];
        if (!recognized) return current;
        return {
          ...current,
          answers: {
            ...current.answers,
            [munNo]: { ...recognized, edited: true, needsReview: false }
          }
        };
      });
    };

    const handleRadioChange = (idx, value) => {
        const munNo = idx + 1;
        const updatedValues = {
            ...selectedValues,
            [munNo]: value
        };
        setSelectedValues(updatedValues);
        markRecognizedAnswerReviewed(munNo);
    };

     
  function fncSelect_list() {
    const acaCode = fnc.getCookie('acaCode');
    
    fnc.sendAxios('/select/lms/course/omrGetDap', { acaCode, parentCode: lmsListCode }, (res) => {
      if (res && Array.isArray(res)) { 
        const fetchedList = getRecords(res);
        setList(fetchedList);
        setQuestionSettingsReady(false);
        fncSelectQuestionSettings(fetchedList);
        fncSelectModelAnswerSheet();
      } else {
        console.log(res,"kuesbLmsRoutes/select/lms/course/omrGetDap");
      }
    });
  }

  function fncSelectQuestionSettings(fetchedList) {
    const acaCode = fnc.getCookie('acaCode');

    fnc.sendAxios('/select/lms/course/omrQuestionSettings', { acaCode, parentCode: lmsListCode }, (res) => {
      if (!Array.isArray(res)) {
        setQuestionSettingsReady(true);
        return;
      }

      const settingMap = res.reduce((map, row) => {
        const munNo = Number(row.munNo);
        if (!map[munNo]) {
          map[munNo] = {
            questionType: ['objective', 'shortAnswer', 'subjective'].includes(row.questionType)
              ? row.questionType
              : 'subjective',
            criteria: [],
            modelAnswerText: row.modelAnswerText || ''
          };
        }
        if (Number(row.criterionNo) > 0) {
          map[munNo].criteria.push({
            text: row.criterionText || '',
            valueType: row.valueType === 'ratio' ? 'ratio' : 'score',
            value: row.criterionValue == null ? '' : String(row.criterionValue)
          });
        }
        return map;
      }, {});

      setList(fetchedList.map((item) => {
        const setting = settingMap[Number(item.munNo)];
        const hasSubjectiveSetting = Boolean(
          setting?.criteria?.length || String(setting?.modelAnswerText || '').trim()
        );
        const questionType = (
          item.questionType === 'objective'
          && setting?.questionType === 'subjective'
          && !hasSubjectiveSetting
        ) ? 'objective' : (setting?.questionType || item.questionType);
        return {
          ...item,
          questionType,
          criteria: setting?.criteria || [],
          modelAnswerText: setting?.modelAnswerText || ''
        };
      }));
      setQuestionSettingsReady(true);
    });
  }

  function fncSelectModelAnswerSheet() {
    const acaCode = fnc.getCookie('acaCode');
    fnc.sendAxios('/select/lms/course/omrAnswerSheet', { acaCode, parentCode: lmsListCode }, (res) => {
      const row = Array.isArray(res) ? res[0] : null;
      setModelAnswerSheet({
        imageKey: String(row?.imageKey || '').trim(),
        imageName: String(row?.imageName || '').trim()
      });
    });
  }



  
  function getRecords(res) {
    let records = [];
    for (let i = 0; i < res.length; i++) {      
        const sno= res[i]["sno"];
        const munNo= res[i]["munNo"];//list 코드 parent Code로 사용
        const dap = res[i]["dap"];
        const point = res[i]["point"];//배점

        const normalizedDap = String(dap ?? '').trim();
        const questionType = [1, 2, 3, 4, 5].includes(Number(normalizedDap))
          ? 'objective'
          : normalizedDap ? 'shortAnswer' : 'subjective';
        records.push({ sno, munNo, dap, point, questionType, criteria: [], modelAnswerText: '' });
    }
    return records;
  }

  const recognizeAnswerSheet = async (attachment) => {
    if (!attachment || list.length === 0) return;
    if (!questionSettingsReady) {
      setAnswerSheetState((current) => ({
        ...current,
        error: '문항 유형을 불러오는 중입니다. 잠시 후 다시 판독해 주세요.'
      }));
      return;
    }

    const requestNo = ++answerSheetRequestRef.current;
    setAnswerSheetState((current) => ({
      ...current,
      attachment,
      answers: {},
      warnings: [],
      status: 'recognizing',
      error: ''
    }));

    try {
      const response = await extractOmrAnswerSheet({
        answerSheetAttachment: attachment,
        questions: list.map((item, index) => ({
          questionNo: index + 1,
          questionType: item.questionType
        }))
      });
      if (answerSheetRequestRef.current !== requestNo) return;

      const recognizedAnswers = response.answers.reduce((map, item) => {
        const munNo = Number(item.questionNo);
        if (Number.isInteger(munNo)) map[munNo] = item;
        return map;
      }, {});

      setSelectedValues((current) => {
        const next = { ...current };
        response.answers.forEach((item) => {
          const munNo = Number(item.questionNo);
          if (Number.isInteger(munNo) && String(item.answer || '').trim()) {
            next[munNo] = item.answer;
          }
        });
        return next;
      });
      setEssayStates((current) => {
        const next = { ...current };
        response.answers.forEach((item) => {
          const munNo = Number(item.questionNo);
          if (item.questionType === 'subjective' && Number.isInteger(munNo)) {
            next[munNo] = {
              ...next[munNo],
              result: null,
              error: ''
            };
          } else if (item.questionType === 'shortAnswer' && Number.isInteger(munNo)) {
            next[munNo] = {
              ...next[munNo],
              showShortAnswerPreview: Boolean(String(item.answer || '').trim())
            };
          }
        });
        return next;
      });
      setAnswerSheetState((current) => ({
        ...current,
        attachment,
        answers: recognizedAnswers,
        warnings: response.warnings,
        status: 'success',
        error: ''
      }));
    } catch (error) {
      if (answerSheetRequestRef.current !== requestNo) return;
      setAnswerSheetState((current) => ({
        ...current,
        attachment,
        answers: {},
        warnings: [],
        status: 'error',
        error: error?.message || '전체 답안지를 판독하지 못했습니다.'
      }));
    }
  };

  const attachAnswerSheet = async (sourceFile) => {
    if (!sourceFile) return;

    const requestNo = ++answerSheetRequestRef.current;
    setAnswerSheetState((current) => ({ ...current, status: 'preparing', error: '' }));
    try {
      const file = normalizeIncomingImageFile(sourceFile, 'clipboard-answer-sheet');
      const preparedFile = await prepareEssayAttachment(file, {
        maxImageEdge: 3200,
        maxUploadBytes: 6 * 1024 * 1024
      });
      if (preparedFile.type === 'application/pdf') {
        throw new Error('전체 답안지는 JPG, PNG 또는 WEBP 이미지로 첨부해 주세요.');
      }
      const attachment = createEssayAttachmentValue(preparedFile);
      if (answerSheetRequestRef.current !== requestNo) {
        releaseEssayAttachmentValue(attachment);
        return;
      }

      setAnswerSheetState((current) => {
        releaseEssayAttachmentValue(current.attachment);
        const next = {
          attachment,
          answers: {},
          warnings: [],
          status: 'idle',
          error: ''
        };
        answerSheetStateRef.current = next;
        return next;
      });
      await recognizeAnswerSheet(attachment);
    } catch (error) {
      if (answerSheetRequestRef.current !== requestNo) return;
      setAnswerSheetState((current) => ({
        ...current,
        status: 'error',
        error: error?.message || '전체 답안지 이미지를 처리하지 못했습니다.'
      }));
    }
  };

  const openAnswerSheetCrop = (file) => {
    if (!file) return;
    if (file.type && !file.type.startsWith('image/')) {
      setAnswerSheetState((current) => ({
        ...current,
        status: 'error',
        error: '답안지는 이미지 파일로 촬영하거나 선택해 주세요.'
      }));
      return;
    }
    if (file.size > 20 * 1024 * 1024) {
      setAnswerSheetState((current) => ({
        ...current,
        status: 'error',
        error: '답안지 이미지는 20MB 이하만 사용할 수 있습니다.'
      }));
      return;
    }
    setAnswerSheetCropFile(file);
  };

  const handleAnswerSheetImageChange = (event) => {
    const input = event.currentTarget;
    const file = input.files?.[0];
    input.value = '';
    if (file) openAnswerSheetCrop(file);
  };

  const applyAnswerSheetCrop = (croppedFile) => {
    setAnswerSheetCropFile(null);
    attachAnswerSheet(croppedFile);
  };

  const handleAnswerSheetPaste = (event) => {
    const imageItem = Array.from(event.clipboardData?.items || [])
      .find((item) => item.kind === 'file' && item.type.startsWith('image/'));
    if (!imageItem) return;
    event.preventDefault();
    const confirmed = window.confirm(
      '답안지 이미지를 붙여 넣으면 AI 판독 결과가 현재 답안 칸에 반영됩니다.\n기존 답안은 자동으로 되돌릴 수 없습니다. 계속하시겠습니까?'
    );
    if (!confirmed) return;
    openAnswerSheetCrop(imageItem.getAsFile());
  };

  const handleAnswerSheetDrop = (event) => {
    event.preventDefault();
    const file = Array.from(event.dataTransfer?.files || [])
      .find((item) => item.type.startsWith('image/'));
    if (file) openAnswerSheetCrop(file);
  };

  const removeAnswerSheet = () => {
    answerSheetRequestRef.current += 1;
    setAnswerSheetState((current) => {
      releaseEssayAttachmentValue(current.attachment);
      const next = createEmptyAnswerSheetState();
      answerSheetStateRef.current = next;
      return next;
    });
  };



  const updateEssayState = (munNo, updater) => {
    setEssayStates((current) => {
      const previous = current[munNo] || {};
      const next = typeof updater === 'function' ? updater(previous) : updater;
      return { ...current, [munNo]: next };
    });
  };

  const handleShortAnswerChange = (index, value) => {
    handleRadioChange(index, value);
    updateEssayState(index + 1, (current) => ({
      ...current,
      showShortAnswerPreview: false
    }));
  };

  const gradeEssay = async (index) => {
    const item = list[index];
    const munNo = index + 1;
    const essayState = essayStates[munNo] || {};
    const answerText = String(selectedValues[munNo] || '').trim();

    if (!answerText) {
      throw new Error(`${munNo}번 서술형 답안을 입력해 주세요.`);
    }

    const rubricText = buildRubricText(item).slice(0, 4000);
    const problemText = [
      `OMR ${munNo}번 서술형 문항입니다.`,
      '학생 답안을 교사의 채점 기준에 따라 평가하세요.',
      rubricText ? `교사 채점 기준:\n${rubricText}` : ''
    ].filter(Boolean).join('\n\n');

    updateEssayState(munNo, (current) => ({ ...current, status: 'grading', error: '', result: null }));

    try {
      const response = await assessEssay({
        subject: 'integrated',
        taskType: 'diagnose',
        assessmentType: 'constructed',
        gradeLevel: getGradeLevel(choJoongGo),
        problemText,
        answerText,
        rubricText,
        problemAttachment: null,
        answerAttachment: null
      });
      const scorePercent = Math.max(0, Math.min(100, Number(response.result?.overall?.score) || 0));
      const detectedAnswer = String(response.result?.detected?.answer || '').trim();

      if (!answerText && detectedAnswer) {
        setSelectedValues((current) => ({ ...current, [munNo]: detectedAnswer }));
      }
      const result = {
        scorePercent,
        detectedAnswer,
        summary: response.result?.overall?.summary || '',
        confidence: Number(response.result?.detected?.confidence) || 0
      };
      updateEssayState(munNo, (current) => ({
        ...current,
        status: 'success',
        error: '',
        result
      }));
      return result;
    } catch (error) {
      const message = error?.message || 'AI 채점을 완료하지 못했습니다.';
      updateEssayState(munNo, (current) => ({
        ...current,
        status: 'error',
        result: null,
        error: message
      }));
      throw new Error(message);
    }
  };

  async function onsubmit() {
    if (submissionInProgressRef.current) return;

    if (answerSheetState.status === 'preparing' || answerSheetState.status === 'recognizing') {
      alert('전체 답안지 판독이 끝난 뒤 제출해 주세요.');
      return;
    }

    const usesImageComparison = Boolean(
      answerSheetState.attachment?.file && modelAnswerSheet.imageKey
    );

    for (let i = 0; i < list.length && !usesImageComparison; i++) {
      const item = list[i];
      if (item.questionType === 'subjective') {
        const munNo = i + 1;
        const hasText = Boolean(String(selectedValues[munNo] || '').trim());
        if (!hasText) {
          alert(`${munNo}번 서술형 답안을 입력해 주세요.`);
          return;
        }
      } else if (!String(selectedValues[i + 1] || '').trim()) {
        alert('모든 문항에 답을 입력해 주세요.');
        return;
      }
    }

    const rtn = window.confirm(
      usesImageComparison
        ? '선생님 모범답안지와 학생 답안지 원본 이미지를 비교해 채점·제출하시겠습니까?'
        : '답안을 제출하시겠습니까?'
    );
    if(!rtn) return;

    submissionInProgressRef.current = true;
    setSubmissionStage('grading');
    try {
      const subjectiveResults = {};
      const imageComparisonResults = {};
      let submittedAnswerSheet = null;

      if (usesImageComparison) {
        try {
          const response = await gradeOmrAnswerSheets({
            answerSheetAttachment: answerSheetState.attachment,
            modelAnswerSheetKey: modelAnswerSheet.imageKey,
            acaCode: fnc.getCookie('acaCode'),
            parentCode: lmsListCode,
            questions: list.map((item, index) => ({
              questionNo: index + 1,
              questionType: item.questionType,
              point: Number(item.point) || 0,
              teacherTextAnswer: item.modelAnswerText || item.dap || '',
              studentConfirmedAnswer: selectedValues[index + 1] || '',
              criteria: item.criteria || []
            }))
          });
          response.answers.forEach((item) => {
            imageComparisonResults[Number(item.questionNo)] = item;
          });
          submittedAnswerSheet = {
            imageKey: response.answerSheetImageKey || '',
            imageName: response.answerSheetImageName || '',
            mimeType: response.answerSheetMimeType || ''
          };
        } catch (error) {
          alert(error?.message || '모범답안지와 학생 답안지의 이미지 채점에 실패했습니다.');
          return;
        }
      } else {
        const gradingResults = await Promise.all(list.map(async (item, index) => {
          if (item.questionType !== 'subjective') return null;
          try {
            const result = await gradeEssay(index);
            subjectiveResults[index + 1] = result;
            return null;
          } catch (error) {
            return { munNo: index + 1, message: error?.message || 'AI 채점에 실패했습니다.' };
          }
        }));
        const gradingFailure = gradingResults.find(Boolean);
        if (gradingFailure) {
          alert(`${gradingFailure.munNo}번 서술형 AI 채점에 실패했습니다. 답안이나 이미지를 확인한 후 다시 제출해 주세요.`);
          return;
        }
      }

      const useAssignedPoints = list.every((item) => Number.isFinite(Number(item.point)) && Number(item.point) > 0);
      let totalPoints = 0;
      let obtainedPoints = 0;
      const markingValues = [];
      const oxValues = [];

      list.forEach((item, index) => {
        const munNo = index + 1;
        const maxPoint = useAssignedPoints ? Number(item.point) : 1;
        totalPoints += maxPoint;

        if (usesImageComparison) {
          const imageResult = imageComparisonResults[munNo] || {};
          const scorePercent = Math.max(0, Math.min(100, Number(imageResult.scorePercent) || 0));
          obtainedPoints += maxPoint * (scorePercent / 100);
          const correctThreshold = item.questionType === 'subjective' ? 60 : 100;
          oxValues.push(scorePercent >= correctThreshold ? 'O' : 'X');
          markingValues.push(imageResult.studentAnswer || selectedValues[munNo] || '이미지 판독');
        } else if (item.questionType === 'subjective') {
          const aiResult = subjectiveResults[munNo];
          obtainedPoints += maxPoint * (aiResult.scorePercent / 100);
          oxValues.push(aiResult.scorePercent >= 60 ? 'O' : 'X');
          markingValues.push(aiResult.detectedAnswer || selectedValues[munNo] || '서술형 AI 채점');
        } else {
          const isCorrect = normalizeAnswer(item.dap) === normalizeAnswer(selectedValues[munNo]);
          if (isCorrect) obtainedPoints += maxPoint;
          oxValues.push(isCorrect ? 'O' : 'X');
          markingValues.push(selectedValues[munNo]);
        }
      });

      const score = totalPoints > 0 ? Math.round((obtainedPoints / totalPoints) * 1000) / 10 : 0;

      setSubmissionStage('saving');
      await fncInsert_usp_markingOmrSt(lmsListCode, markingValues, oxValues, score, submittedAnswerSheet);
    } catch (error) {
      alert(error?.message || '답안 제출에 실패했습니다. 잠시 후 다시 제출해 주세요.');
    } finally {
      submissionInProgressRef.current = false;
      setSubmissionStage('idle');
    }
  }



function fncInsert_usp_markingOmrSt(parentCode, answers, oxValues, score, answerSheet) {
    const acaCode = fnc.getCookie('acaCode');
    const stCode = fnc.getCookie('stCode');
    
    return fnc.sendAxios('/insert/lms/omr/usp_markingOmrSt', {
      acaCode,
      parentCode,
      stCode,
      answers,
      oxValues,
      score,
      answerSheet
    }, (res) => {
      if (res && res.success && res.result === 'Y') {
        setIsRefresh(!isRefresh);
        alert('제출과 채점이 완료되었습니다.');
      } else {
        console.log(res,"insert/lms/omr/usp_markingOmrSt");
        alert(res?.error || '답안 저장에 실패했습니다.');
      }
    }, (error) => {
      alert(error?.response?.data?.error || '답안 저장에 실패했습니다.');
    });
  }



  //============================================================================
  const recognizedAnswerCount = Object.values(answerSheetState.answers || {})
    .filter((item) => String(item?.answer || '').trim()).length;
  const reviewAnswerCount = Object.values(answerSheetState.answers || {})
    .filter((item) => item?.needsReview).length;
  const isAnswerSheetBusy = answerSheetState.status === 'preparing'
    || answerSheetState.status === 'recognizing';
  const isProcessing = isCroppingAnswerSheet || isAnswerSheetBusy || isSubmitting;
  const progressSteps = isSubmitting ? ['AI 채점', '답안 저장'] : ['이미지 준비', 'AI 답안 판독'];
  const progressStep = (isSubmitting ? submissionStage === 'saving' : answerSheetState.status === 'recognizing') ? 1 : 0;
  const progressTitle = isSubmitting
    ? (submissionStage === 'saving' ? '답안을 저장하고 있습니다' : 'AI 채점 중입니다')
    : (answerSheetState.status === 'recognizing' ? 'AI 답안 판독 중입니다' : '답안지 이미지를 준비하고 있습니다');
  const progressDescription = isSubmitting
    ? (submissionStage === 'saving' ? '채점이 끝났습니다. 제출 결과를 저장하고 있습니다.' : '답안을 분석하고 채점하고 있습니다.')
    : (answerSheetState.status === 'recognizing' ? '문항별 답안을 읽고 있습니다.' : '선택한 답안 영역을 선명하게 처리하고 있습니다.');

  return (
    list.length > 0 && (
        <div className='Detail_omr'>
            <div className='wrap-main'>
                <div className="title">OMR 마킹</div>
                <BillingBalance />
                <section className="answer-sheet-import" aria-busy={isAnswerSheetBusy}>
                  <div className="answer-sheet-import__heading">
                    <div>
                      <strong>A4 전체 답안지 자동 입력</strong>
                      <p>답안지 한 장을 올리면 AI가 문항 번호별로 읽어 아래 답안 칸에 자동 입력합니다.</p>
                    </div>
                    {answerSheetState.status === 'success' && (
                      <span className={reviewAnswerCount > 0 ? 'needs-review' : 'complete'}>
                        {recognizedAnswerCount}/{list.length}문항 판독
                        {reviewAnswerCount > 0 ? ` · ${reviewAnswerCount}문항 확인 필요` : ' · 확인 가능'}
                      </span>
                    )}
                  </div>
                  <div className={`answer-sheet-comparison-mode ${modelAnswerSheet.imageKey ? 'ready' : 'text-mode'}`}>
                    {modelAnswerSheet.imageKey
                      ? '선생님의 전체 모범답안지가 등록되어 있습니다. 제출할 때 두 원본 이미지를 직접 비교해 채점합니다.'
                      : '전체 모범답안지가 아직 없습니다. 현재는 입력된 정답과 채점 기준으로 채점합니다.'}
                  </div>

                  <div
                    className={`answer-sheet-dropzone ${answerSheetState.attachment ? 'has-image' : ''}`}
                    tabIndex="0"
                    onPaste={handleAnswerSheetPaste}
                    onDragOver={(event) => event.preventDefault()}
                    onDrop={handleAnswerSheetDrop}
                  >
                    {answerSheetState.attachment ? (
                      <img src={answerSheetState.attachment.previewUrl} alt="첨부한 전체 답안지 미리보기" />
                    ) : (
                      <div className="answer-sheet-dropzone__empty">
                        <FiUploadCloud className="answer-sheet-upload-icon" aria-hidden="true" />
                        <strong className="answer-sheet-desktop-copy">이 영역을 누르고 Ctrl+V</strong>
                        <strong className="answer-sheet-mobile-copy">답안지 한 장을 올려주세요</strong>
                        <span className="answer-sheet-desktop-copy">또는 이미지 파일을 선택하거나 끌어 놓으세요.</span>
                        <span className="answer-sheet-mobile-copy">촬영하거나 앨범에서 선택하면 답안이 자동 입력돼요.</span>
                      </div>
                    )}

                    <div className="answer-sheet-actions">
                      <label className="answer-sheet-button primary">
                        {answerSheetState.attachment ? '다른 답안지 선택' : '전체 답안지 선택'}
                        <input
                          type="file"
                          accept={ESSAY_IMAGE_ACCEPT}
                          onChange={handleAnswerSheetImageChange}
                          disabled={isAnswerSheetBusy || !questionSettingsReady}
                        />
                      </label>
                      <button
                        type="button"
                        className="answer-sheet-button camera"
                        onClick={() => answerSheetCameraInputRef.current?.click()}
                        disabled={isAnswerSheetBusy || !questionSettingsReady}
                      >
                        <FiCamera aria-hidden="true" />
                        사진 촬영
                      </button>
                      <input
                        ref={answerSheetCameraInputRef}
                        className="answer-sheet-camera-input"
                        type="file"
                        accept="image/*"
                        capture="environment"
                        onChange={handleAnswerSheetImageChange}
                        disabled={isAnswerSheetBusy || !questionSettingsReady}
                      />
                      {answerSheetState.attachment && answerSheetState.status !== 'preparing' && (
                        <>
                          <button
                            type="button"
                            className="answer-sheet-button"
                            onClick={() => recognizeAnswerSheet(answerSheetState.attachment)}
                            disabled={isAnswerSheetBusy}
                          >
                            다시 판독
                          </button>
                          <button
                            type="button"
                            className="answer-sheet-button remove"
                            onClick={removeAnswerSheet}
                            disabled={isAnswerSheetBusy}
                          >
                            이미지 제거
                          </button>
                        </>
                      )}
                    </div>
                  </div>

                  {answerSheetState.status === 'preparing' && (
                    <p className="answer-sheet-status">이미지를 선명하게 처리하고 있습니다…</p>
                  )}
                  {answerSheetState.status === 'recognizing' && (
                    <p className="answer-sheet-status">AI가 답안 칸을 찾아 문항별로 판독하고 있습니다…</p>
                  )}
                  {answerSheetState.error && (
                    <p className="answer-sheet-error" role="alert">{answerSheetState.error}</p>
                  )}
                  {answerSheetState.warnings.length > 0 && (
                    <ul className="answer-sheet-warnings">
                      {answerSheetState.warnings.map((warning, index) => <li key={index}>{warning}</li>)}
                    </ul>
                  )}
                  <p className="answer-sheet-guide">
                    자동 입력된 답은 제출 전에 반드시 확인하세요. 흐리거나 칸을 벗어난 필기는 ‘판독 확인 필요’로 표시됩니다.
                  </p>
                </section>
                <table className="warp-marking-omr">
                    <tbody>
                        {list.map((item, index) => {
                          const munNo = index + 1;
                          const essayState = essayStates[munNo] || {};
                          const aiResult = essayState.result;
                          const recognizedAnswer = answerSheetState.answers?.[munNo];
                          const maxPoint = Number(item.point) || 0;
                          const earnedPoint = aiResult ? maxPoint * (aiResult.scorePercent / 100) : 0;

                          return (
                            <tr className={`tr_queMenu_omr ${item.questionType}`} key={index}>
                              <td>
                                <div className="question-heading">
                                  <span className="NoOmr">{munNo}</span>
                                  <span className="question-type-label">
                                    {item.questionType === 'subjective'
                                      ? '서술형'
                                      : item.questionType === 'shortAnswer' ? '단답형' : '객관식'}
                                  </span>
                                  {recognizedAnswer && (
                                    <span
                                      className={`answer-recognition ${recognizedAnswer.needsReview ? 'needs-review' : 'recognized'}`}
                                      title={recognizedAnswer.warning || `AI 판독 신뢰도 ${recognizedAnswer.confidence}%`}
                                    >
                                      {recognizedAnswer.edited
                                        ? '확인·수정됨'
                                        : recognizedAnswer.needsReview
                                          ? '판독 확인 필요'
                                          : `자동 판독 ${recognizedAnswer.confidence}%`}
                                    </span>
                                  )}
                                  {item.point && <span className='point'>{item.point}점</span>}
                                </div>
                                {recognizedAnswer?.needsReview && recognizedAnswer.warning && (
                                  <p className="answer-recognition-warning">{recognizedAnswer.warning}</p>
                                )}

                                {item.questionType === 'objective' && (
                                  <div className="objective-answer">
                                    {[1, 2, 3, 4, 5].map((value) => (
                                      <label
                                          key={value}
                                          className={`custom-radio ${selectedValues[munNo] == value ? 'selected' : ''}`}
                                          data-number={value}
                                      >
                                        <input
                                            type="radio"
                                            name={`question${munNo}`}
                                            value={value}
                                            aria-label={`${munNo}번 문항 ${value}번 답안`}
                                            checked={selectedValues[munNo] == value}
                                            onChange={() => handleRadioChange(index, value)}
                                        />
                                      </label>
                                    ))}
                                  </div>
                                )}

                                {item.questionType === 'shortAnswer' && (
                                  <div className="short-answer-editor">
                                    {essayState.showShortAnswerPreview && String(selectedValues[munNo] || '').trim() ? (
                                      <MathMarkdown
                                        className="short-answer-katex-preview"
                                        value={formatShortAnswerForKatex(selectedValues[munNo])}
                                      />
                                    ) : (
                                      <input
                                          className="markingValue_omr short-answer"
                                          type="text"
                                          spellCheck="false"
                                          autoComplete="off"
                                          value={selectedValues[munNo] || ''}
                                          onChange={(event) => handleShortAnswerChange(index, event.target.value)}
                                      />
                                    )}
                                    {String(selectedValues[munNo] || '').trim() && (
                                      <button
                                        type="button"
                                        className="short-answer-preview-toggle"
                                        onClick={() => updateEssayState(munNo, (current) => ({
                                          ...current,
                                          showShortAnswerPreview: !current.showShortAnswerPreview
                                        }))}
                                      >
                                        {essayState.showShortAnswerPreview ? '원문 수정' : 'KaTeX로 보기'}
                                      </button>
                                    )}
                                  </div>
                                )}

                                {item.questionType === 'subjective' && (
                                  <div className="essay-answer">
                                    {String(selectedValues[munNo] || '').trim() && (
                                      <div className="essay-response-viewer">
                                        <MathMarkdown
                                          className="essay-math-preview"
                                          value={String(selectedValues[munNo] || '')}
                                          renderBareLatex
                                        />
                                      </div>
                                    )}
                                    {essayState.error && <p className="essay-error" role="alert">{essayState.error}</p>}

                                    {aiResult && (
                                      <div className="essay-grade-result" role="status">
                                        <div>
                                          <strong>AI 채점 {aiResult.scorePercent}점</strong>
                                          {maxPoint > 0 && <span>배점 {earnedPoint.toFixed(1)} / {maxPoint}점</span>}
                                          {aiResult.detectedAnswer && <span>필기 판독 신뢰도 {aiResult.confidence}%</span>}
                                        </div>
                                        {aiResult.summary && <p>{aiResult.summary}</p>}
                                      </div>
                                    )}
                                  </div>
                                )}
                              </td>
                            </tr>
                          );
                        })}
                    </tbody>
                </table>
            </div>
            <Button
              className='btnSubmit'
              variant="contained"
              size="large"
              startIcon={<FiSend aria-hidden="true" />}
              onClick={onsubmit}
              disabled={isProcessing}
              aria-busy={isProcessing}
            >
              {isSubmitting ? 'AI 채점 및 제출 중…' : '답안 제출'}
            </Button>

            <Modal open={isProcessing} className="omr-submit-modal" disableEscapeKeyDown>
              <div
                className="omr-submit-progress"
                role="dialog"
                aria-modal="true"
                aria-labelledby="omr-submit-title"
                aria-describedby="omr-submit-description"
                tabIndex={-1}
              >
                <CircularProgress size={60} thickness={4} color="inherit" aria-label={isSubmitting ? '답안 제출 처리 중' : '답안지 판독 처리 중'} />
                <div role="status" aria-live="polite" aria-atomic="true">
                  <strong id="omr-submit-title">{progressTitle}</strong>
                  <p id="omr-submit-description">{progressDescription}</p>
                </div>
                <ol className="omr-submit-steps" aria-label="진행 단계">
                  {progressSteps.map((step, index) => (
                    <li
                      key={step}
                      className={index === progressStep ? 'active' : index < progressStep ? 'complete' : ''}
                      aria-current={index === progressStep ? 'step' : undefined}
                    >
                      <span aria-hidden="true">{index < progressStep ? '✓' : index + 1}</span>
                      {step}
                    </li>
                  ))}
                </ol>
                <p className="omr-submit-wait">완료될 때까지 잠시만 기다려 주세요.</p>
              </div>
            </Modal>

            {answerSheetCropFile && (
              <AnswerSheetCropModal
                file={answerSheetCropFile}
                onCancel={() => setAnswerSheetCropFile(null)}
                onApply={applyAnswerSheetCrop}
                onProcessingChange={setIsCroppingAnswerSheet}
              />
            )}
        </div>
    )
);
};

export default Detail_omr;
